// Copyright: Ubisense Limited 2010-2017
import myw from 'myWorld/base/core';
import './referenceFieldViewer';

/**
 * Extends default behaviour with tooltip listing feature urns;
 *
 * @name ReferenceTooltipFieldViewer
 * @constructor
 * @extends {ReferenceFieldViewer}
 */
myw.ReferenceTooltipFieldViewer = myw.ReferenceFieldViewer.extend({
    events: {
        mouseover: 'showToolTip',
        click: 'followRelationship'
    },

    initialize(owner, feature, fieldDD, options) {
        myw.ReferenceFieldViewer.prototype.initialize.call(this, owner, feature, fieldDD, options);
    },

    showToolTip() {
        if (typeof this.feature.properties[this.fieldName] == 'string') {
            this.$el.prop('title', this.feature.properties[this.fieldName]);
            return;
        }

        let str = '';
        (this.feature.properties[this.fieldName] || []).map(f => {
            str += `${f}\n`;
        });
        this.$el.prop('title', str);
    }
});

export default myw.ReferenceTooltipFieldViewer;
